var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-import", style: { width: _vm.width } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !!_vm.loading,
              expression: "!!loading"
            }
          ],
          staticClass: "loader u-stretch"
        },
        [_c("ui-loader", { staticClass: "ui-loader" })],
        1
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "close cl-placeholder",
          attrs: { "aria-label": "閉じる" },
          on: { click: _vm.$popup.hide }
        },
        [_c("icon-close")],
        1
      ),
      _vm._v(" "),
      _vm.result && _vm.succeeded > 0 && !_vm.result.failed.length
        ? _c("icon-success", { staticClass: "icon" })
        : _vm._e(),
      _vm._v(" "),
      _c("h1", { staticClass: "h2 t-center" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.subtitle,
              expression: "subtitle"
            }
          ],
          staticClass: "caption t12 t-center"
        },
        [_vm._v(_vm._s(_vm.subtitle))]
      ),
      _vm._v(" "),
      _vm.mode === "upload"
        ? _c("div", { staticClass: "upload" }, [
            _c(
              "label",
              { staticClass: "btn primary", attrs: { for: "upfile" } },
              [
                _c("icon-file"),
                _vm._v("\n            ファイルを選択する\n        ")
              ],
              1
            ),
            _vm._v(" "),
            _c("input", {
              attrs: { type: "file", id: "upfile", accept: _vm.Types },
              on: { change: _vm.upload }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.mode === "select"
        ? _c("div", { staticClass: "select" }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "carousel" }, [
                _c(
                  "div",
                  {
                    staticClass: "inner",
                    style: { left: -_vm.index * 392 + "px" }
                  },
                  _vm._l(_vm.previews, function(rows, j) {
                    return _c(
                      "div",
                      {
                        key: "preview" + j,
                        staticClass: "preview",
                        style: {
                          cursor: _vm.index === j ? "default" : "pointer",
                          opacity: _vm.index === j ? 1 : 0.5
                        },
                        on: {
                          click: function($event) {
                            _vm.index = j
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "u-row",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                              }
                            }
                          },
                          [
                            _c("ui-dropdown", {
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var active = ref.active
                                      var toggle = ref.toggle
                                      return [
                                        _c("ui-select", {
                                          class: { active: active },
                                          attrs: { label: _vm.label(j) },
                                          nativeOn: {
                                            click: function($event) {
                                              return toggle($event)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("ui-options", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: active,
                                              expression: "active"
                                            }
                                          ],
                                          attrs: { options: _vm.categories(j) },
                                          on: { update: _vm.set }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "header row u-row" }, [
                          _vm.header(j)
                            ? _c("span", { staticClass: "w5 selected" }, [
                                _vm._v(_vm._s(_vm.header(j)))
                              ])
                            : _vm.hasHeader
                            ? _c("span", [_vm._v(_vm._s(rows[0]))])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "scroll" },
                          _vm._l(rows.slice(_vm.hasHeader), function(value, i) {
                            return _c(
                              "div",
                              { key: "column" + i, staticClass: "row u-row" },
                              [_c("span", [_vm._v(_vm._s(value))])]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dots" },
                _vm._l(_vm.columns, function(_, i) {
                  return _c("span", {
                    key: i,
                    staticClass: "dot",
                    class: { active: i === _vm.index },
                    on: {
                      click: function($event) {
                        _vm.index = i
                      }
                    }
                  })
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.index === _vm.columns.length - 1,
                    expression: "index === columns.length -1"
                  }
                ],
                staticClass: "notice t12 t-center"
              },
              [
                _vm._v(
                  "\n            ※既存のデータIDが含まれる場合、該当する物件データが上書きされますのでご注意ください。\n        "
                )
              ]
            ),
            _vm._v(" "),
            _vm.index === _vm.columns.length - 1
              ? _c(
                  "a",
                  {
                    staticClass: "btn primary",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.complete($event)
                      }
                    }
                  },
                  [
                    _c("icon-import"),
                    _vm._v("\n            インポートする\n        ")
                  ],
                  1
                )
              : _c(
                  "a",
                  {
                    staticClass: "btn primary next",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.index++
                      }
                    }
                  },
                  [
                    _vm._v("\n            次へ進む\n            "),
                    _c("icon-arrow")
                  ],
                  1
                )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.mode === "complete"
        ? _c("div", { staticClass: "complete t-center" }, [
            _vm.result && _vm.succeeded > 0
              ? _c("div", [
                  _vm._v(
                    "物件データ" +
                      _vm._s(_vm.succeeded) +
                      "件が正常に登録されました"
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.result && _vm.result.failed.length
              ? _c("section", [
                  _c(
                    "b",
                    { staticClass: "message u-row" },
                    [
                      _c("icon-attention"),
                      _vm._v(
                        "\n                下記のデータは登録できませんでした\n            "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "errors" },
                    _vm._l(_vm.errors, function(ref, i) {
                      var code = ref.code
                      var indexes = ref.indexes
                      return _c(
                        "div",
                        { key: "error" + i, staticClass: "error" },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.Errors[code]) +
                              "\n                    "
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "indexes",
                              attrs: { title: _vm.detail(indexes) }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.detail(indexes)) +
                                  "\n                    "
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "CSV・Excelのデータを修正し、再度アップロードしてください。"
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn secondary finish",
                on: { click: _vm.finish }
              },
              [_vm._v("\n            閉じる\n        ")]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }